import React, { forwardRef } from 'react';
import './slider.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IImageSlider } from '../../../../utils/types/contentful';
import { Button } from '../../Elements';

export const SliderArrow = ({ onClick, button, placement }) => (
  <div
    className={`absolute z-10 ${placement}`}
    onClick={onClick}>
    {button}
  </div>
);

const SliderWrapper: React.FC<IImageSlider> = forwardRef(
  (
    {
      afterChange,
      children,
      hasDots,
      isInfinite,
      hasAutoPlay,
      autoplaySpeed,
      slidesToShow,
      slidesToScroll,
      centerPadding,
      hasArrows,
      centerMode,
      responsive,
      nextArrow,
      prevArrow,
      vertical,
      initialSlide = 0,
      ...props
    },
    ref
  ) => {
    const settings = {
      easing: 'ease-in',
      className: 'slider',
      dots: hasDots,
      infinite: isInfinite,
      speed: 500,
      autoplaySpeed,
      autoplay: hasAutoPlay,
      slidesToShow,
      slidesToScroll,
      swipeToSlide: true,
      centerPadding,
      centerMode,
      responsive,
      arrows: hasArrows,
      nextArrow,
      prevArrow,
      vertical,
      afterChange,
      initialSlide,
      ...props,
    };
    return (
      <Slider
        ref={ref}
        {...settings}>
        {children}
      </Slider>
    );
  }
);

export { SliderWrapper as Slider };
